import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";

// ============================================================================
// crm_lost_reasons — เหตุผลที่แพ้ดีล
// ============================================================================
export const crmLostReasons = sqliteTable("crm_lost_reasons", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  name: text("name").notNull(),
  sortOrder: integer("sort_order").default(0),
  isActive: integer("is_active").default(1),
});

// Type exports
export type CrmLostReason = typeof crmLostReasons.$inferSelect;
export type NewCrmLostReason = typeof crmLostReasons.$inferInsert;
